import { render, staticRenderFns } from "./ReturnProductDetail.vue?vue&type=template&id=56ea2e85&scoped=true&"
import script from "./ReturnProductDetail.vue?vue&type=script&lang=js&"
export * from "./ReturnProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea2e85",
  null
  
)

export default component.exports